import {observer} from "mobx-react";
import Accordion from "../../models/Accordion";
import {useStore} from "../../stores/Store";
import {EntityStatus} from "../../models/EntityStatus";
import ConfirmationDialog from "../Misc/ConfirmationDialog/ConfirmationDialog";
import {PublicOff} from "@mui/icons-material";

interface Props {
    accordion: Accordion
}

export default observer(({accordion} : Props) => {
    const { LanguageStore, AccordionStore } = useStore();
    const { currentLanguageMessages } = LanguageStore;
    const { update } = AccordionStore;

    const unpublish = () => {
        update({...accordion, status: EntityStatus.draft});
    }

    return (
        <ConfirmationDialog
            buttonIcon={<PublicOff />}
            buttonColor={'info'}
            buttonLabel={currentLanguageMessages.GeneralComponentLabels.unpublishButtonLabel}
            confirmationText={currentLanguageMessages.AccordionsPage.UnpublishAccordion.ConfirmationDialogContent}
            confirmationTitle={currentLanguageMessages.AccordionsPage.UnpublishAccordion.ConfirmationDialogTitle}
            confirmCallback={unpublish}
        />
    )
})